import React from 'react';
import GridTable from '@nadavshaar/react-grid-table';
import { isMobile } from 'react-device-detect';

const TabServicesAndParts = ({
  service,
  aeService,
  parts,
  values,
  totalServices,
  totalAeServices,
  totalParts,
  totalSum,
  columnsService,
  columnsPiece,
}) => {
  return (
    <>
      <div style={{ marginTop: 20 }}>
        <div className="grid-table-wrapper">
          <div
            className="bodyshop-body modal-budget modal-budget-gridtable gridtable-for-service-budget"
            style={{ maxHeight: 'fit-content' }}
          >
            <GridTable
              columns={[...columnsService('Relação dos Serviços')]}
              rows={[
                ...service.map((s) => ({ ...s, category: 'Funilaria' })),
                ...aeService.map((s) => ({ ...s, category: 'Estética' })),
              ]}
              enableColumnsReorder={false}
              showSearch={false}
              canReorder={false}
              isPaginated={false}
              showColumnVisibilityManager={false}
              showRowsInformation={false}
              texts={{ noResults: 'Nenhum resultado foi encontrado' }}
            />
          </div>
        </div>

        {/* Soma geral */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'baseline',
            marginBottom: 16,
            marginTop: 16,
          }}
        >
          <text
            style={{
              color: 'white',
              fontSize: '16px',
              marginRight: 10,
            }}
          >
            Soma total:
          </text>
          <span
            style={{
              color: '#62C300',
              fontWeight: 'light',
              fontSize: '16px',
            }}
          >
            {(totalServices + totalAeServices).toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </span>
        </div>

        {/* Descontos unificados */}
        {(() => {
          const bodyshopDiscount =
            parseFloat(values?.bodyshop_discount) || 0;
          const aestheticsDiscount =
            parseFloat(values?.aesthetics_discount) || 0;
          const totalValue = totalServices + totalAeServices;

          const totalDiscount = bodyshopDiscount + aestheticsDiscount;
          const totalPercentage = totalDiscount
            ? (totalDiscount / totalValue) * 100
            : 0;

          const totalPercentageFormatted = totalPercentage.toLocaleString(
            'pt-BR',
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          );

          if (totalDiscount > 0) {
            return (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'baseline',
                  marginBottom: 16,
                  marginTop: -8,
                }}
              >
                <text
                  style={{
                    color: 'white',
                    fontSize: '14px',
                    marginRight: 10,
                  }}
                >
                  Desconto total ({totalPercentageFormatted}%):
                </text>
                <span
                  style={{
                    color: '#ff6b6b',
                    fontWeight: 'light',
                    fontSize: '14px',
                  }}
                >
                  -
                  {totalDiscount.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </span>
              </div>
            );
          }
          return null;
        })()}
      </div>

      {/* Peças */}
      <div>
        <div
          className="bodyshop-body modal-budget modal-budget-gridtable gridtable-for-piece-budget"
          style={{ maxHeight: 'fit-content' }}
        >
          <GridTable
            columns={columnsPiece()}
            rows={parts}
            enableColumnsReorder={false}
            showSearch={false}
            canReorder={false}
            isPaginated={false}
            showColumnVisibilityManager={false}
            showRowsInformation={false}
            texts={{ noResults: 'Nenhum resultado foi encontrado' }}
          />
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'baseline',
            marginTop: 16,
            marginBottom: 24,
          }}
        >
          <text
            style={{
              color: 'white',
              fontSize: '16px',
              marginRight: 10,
            }}
          >
            {' '}
            Soma de peças:{' '}
          </text>
          <span
            style={{
              color: '#62C300',
              fontWeight: 'light',
              fontSize: '16px',
            }}
          >
            {totalParts.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </span>
        </div>

        {/* Desconto Peças */}
        {(() => {
          const partsDiscount = parseFloat(values?.parts_discount) || 0;
          const partsPercentage =
            parseFloat(values?.parts_percentage_discount) || 0;

          if (partsDiscount > 0) {
            return (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'baseline',
                  marginBottom: 16,
                  marginTop: -16,
                }}
              >
                <text
                  style={{
                    color: 'white',
                    fontSize: '14px',
                    marginRight: 10,
                  }}
                >
                  Desconto peças ({partsPercentage}%):
                </text>
                <span
                  style={{
                    color: '#ff6b6b',
                    fontWeight: 'light',
                    fontSize: '14px',
                  }}
                >
                  -
                  {partsDiscount.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </span>
              </div>
            );
          }
          return null;
        })()}
      </div>
      <div
        className="header-title"
        style={{
          display: 'flex',
          justifyContent: isMobile ? 'center' : 'flex-end',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 10,
          marginBottom: 16,
        }}
      >
        <h4 className="modal-title">
          Valor total:{' '}
          <span
            style={{
              marginLeft: 10,
              color: '#62C300',
              fontWeight: 'bold',
              fontSize: '18px',
            }}
          >
            {(() => {
              const totalDiscounts =
                (parseFloat(values?.bodyshop_discount) || 0) +
                (parseFloat(values?.aesthetics_discount) || 0) +
                (parseFloat(values?.parts_discount) || 0);

              const finalTotal = totalSum - totalDiscounts;

              return finalTotal.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              });
            })()}
          </span>
        </h4>
      </div>

      {/* Total de Descontos */}
      {(() => {
        const totalDiscounts =
          (parseFloat(values?.bodyshop_discount) || 0) +
          (parseFloat(values?.aesthetics_discount) || 0) +
          (parseFloat(values?.parts_discount) || 0);

        if (totalDiscounts > 0) {
          return (
            <div
              style={{
                display: 'flex',
                justifyContent: isMobile ? 'center' : 'flex-end',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: 10,
                marginBottom: 16,
              }}
            >
              <text
                style={{
                  color: 'white',
                  fontSize: '14px',
                  fontWeight: '400',
                }}
              >
                (Valor original:{' '}
                {totalSum.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}{' '}
                - Desconto total:{' '}
                {totalDiscounts.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}
                )
              </text>
            </div>
          );
        }
        return null;
      })()}
    </>
  );
};

export default TabServicesAndParts;
